"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var FreeFieldResource = /** @class */ (function (_super) {
    tslib_1.__extends(FreeFieldResource, _super);
    function FreeFieldResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeFieldResource.endpoint = '/freefields';
    FreeFieldResource.MODEL_NAME = 'freefield';
    return FreeFieldResource;
}(base_1.default));
exports.default = FreeFieldResource;
//# sourceMappingURL=freefield.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/freefield.js
// module id = CWg6
// module chunks = 0